'use strict';

import appStore from '@uw-it-sis/lib-react/lib/AppStore';

class Api {
    constructor() {
        this.baseUrl = "api";
    }

    getInstructors() {
        return appStore.getHttpClient().doGet(`${this.baseUrl}/instructors`, 'getInstructors');
    }

    getSubjectAreas() {
        return appStore.getHttpClient().doGet(`${this.baseUrl}/subjectAreas`, 'getSubjectAreas');
    }

    async findCourses(postBody) {
        return await appStore.getHttpClient().doPost(`${this.baseUrl}/courses`, postBody, 'searchCourses');
    }

    getSubjectAreaHierarchy() {
        return appStore.getHttpClient().doGet(`${this.baseUrl}/subjectAreaHierarchy`, 'getSubjectAreaHierarhcy');
    }
    getSyllabus(sectionId) {
        return appStore.getHttpClient().doGet(`${this.baseUrl}/syllabi/${sectionId}`, 'getSyllabus');
    }

}

export default new Api();